'use client';

import { HeroUIProvider } from '@heroui/react';
import { SWRConfig } from 'swr';

interface HeroUIProviderProps {
    children: React.ReactNode;
}

export default function Providers({ children }: HeroUIProviderProps) {
    return (
        <SWRConfig value={{ provider: () => new Map() }}>
            <HeroUIProvider>{children}</HeroUIProvider>
        </SWRConfig>
    );
}
